import PropTypes from "prop-types";
import { connect } from "react-redux";
import React from "react";
import {
  MSpinner,
  Map,
  StandardPinSize,
  MDialogSelectList,
  MToolTip,
  FauxHeader,
  MultiSelect,
  MenuButton,
  RMDButton,
} from "components/Shared";
import { getCasePinURL, getInspectorPinURL, getCasePinIconURL } from "components/Shared/Map";
import SelectionDetails, {
  DISPLAY_MODE_CASE_DETAILS,
  DISPLAY_MODE_INSPECTOR_CASES,
} from "components/Assignment/SelectionDetails";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { CaseHeader } from "components/Homeowner/CaseForms";
import {
  ASSIGNMENT_MODE_APPRAISAL,
  ASSIGNMENT_MODE_INSURANCE,
  ASSIGNMENT_APPRAISAL_TITLE,
  ASSIGNMENT_INSURANCE_TITLE,
} from "components/Assignment/index";
import { preferenceJustLoaded } from "actions/preferences";
import { fontColor, backgroundColor } from "components/Shared/systemColors";
import FieldRepProfileV2 from "components/Homeowner/FieldReps/FieldRepProfileV2";
import { setCoreLayoutHeaderVisibility } from "actions/layout";
import {
  AssignmentToolStateList,
  AssignmentToolCaseDetailsHeight,
  AssignmentToolFilterInspectionTypeGroup,
  AssignmentToolFilterExtras,
  AssignmentToolFilterDue,
  AssignmentToolFilterOrdered,
  AssignmentToolFilterCounty,
} from "typeConstants/preferenceTypes";
import { DATA_TYPE_DAYS_ELAPSED, DATA_TYPE_PHONE_NUMBER } from "typeConstants/dataTypes";
import MSplitter from "components/Shared/MSplitter.tsx";
import AppraiserProfilePanel from "containers/Appraiser/ProfilePanel";
import LoadingCover from "components/Shared/LoadingCover.tsx";
import {
  COMMERCIAL_EXT,
  COMMERCIAL_INT,
  FARM,
  HIGH_VALUE,
  LENDER,
  WIND,
  ELITE_HIGH_VALUE,
  BUILDERS_RISK,
} from "typeConstants/designationCodes";
import moment from "moment";
import { PIN_NAME_OTHER_FR_APPTS, PIN_NAME_SELECTED_FR_APPTS } from "typeConstants";
import { AssignmentPinsContext, pinCodes } from "./AssignmentPinsProvider.tsx";

const EXTRA_FILTERS_ASSIGNED_CASES = "EXTRA_FILTERS_ASSIGNED_CASES";
const EXTRA_FILTERS_SURGE = "EXTRA_FILTERS_SURGE";
const EXTRA_FILTERS_PREFERRED_APPOINTMENT = "EXTRA_FILTERS_PREFERRED_APPOINTMENT";
const EXTRA_FILTERS_BREADCRUMBS = "EXTRA_FILTERS_BREADCRUMBS";
const EXTRA_FILTERS_COUNTY_PROFICIENCY = "EXTRA_FILTERS_COUNTY_PROFICIENCY";
const EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER = "EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER";
const EXTRA_FILTERS_NON_QUICKLIST_CASES = "EXTRA_FILTERS_NON_QUICKLIST_CASES"; // this will show cases outside of the quicklist filter that are in the same zip as quicklist cases
const EXTRA_FILTERS_AUTO_PULLED = "EXTRA_FILTERS_AUTO_PULLED";
const EXTRA_FILTERS_APPRAISALS_ONLY = "EXTRA_FILTERS_APPRAISALS_ONLY";
const EXTRA_FILTERS_TRAINEES = "EXTRA_FILTERS_TRAINEES";
const EXTRA_FILTERS_FR_COUNTY_COVERAGE = "EXTRA_FILTERS_FR_COUNTY_COVERAGE";
const EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE = "EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE";
const EXTRA_FILTERS_HIDE_FR_COVERAGE_TOOLTIP = "EXTRA_FILTERS_HIDE_FR_COVERAGE_TOOLTIP";

const SEARCH_TYPE_ASSIGNEE = "SEARCH_TYPE_ASSIGNEE";
const SEARCH_TYPE_ASSIGNEE_HIDDEN_COUNTY = "SEARCH_TYPE_ASSIGNEE_HIDDEN_COUNTY";
const SEARCH_TYPE_ASSIGNEE_HIDDEN_FROM_MAP = "SEARCH_TYPE_ASSIGNEE_HIDDEN_FROM_MAP";
const SEARCH_TYPE_CASE = "SEARCH_TYPE_CASE";
const SEARCH_TYPE_CASE_HIDDEN = "SEARCH_TYPE_CASE_HIDDEN";
const SEARCH_TYPE_ZIP_CODE = "SEARCH_TYPE_ZIP_CODE";

const MIN_EXPANDED_DETALS_HEIGHT = 347;
const COLLAPSED_DETAILS_HEIGHT = 175;
const MAX_DETAILS_HEIGHT = 1000; // i had an error in testing where my height shot over 500000000 or so, i fixed it, but heres a max just to make sure, because i wouldnt want some user not able to use the tool because resize messed up

const ASSIGNED_CASES_DAYS_TO_LOOK = moment().day() === 5 || moment().day() === 6 ? 3 : 2; //If it's friday or saturday we need 3 days worth of cases since we skip sunday

export const mapArrayOfPolygons = (
  countyList,
  countyBoundaries,
  mouseOver,
  mouseOut,
  flattenedAppraiserCountyIds = null,
) => {
  let mapArrayOfArrayToLatLng = (c) => c.map((pos) => ({ lat: pos[1], lng: pos[0] }));
  let noCoverageStates = [
    ...new Set(countyList?.map((c) => (c.hasCoverage === false ? c.stateAbbreviation : "")).filter((s) => s !== "")),
  ]; // must map and filter countyList outside of creating polygon object to avoidbug that randomly selects counties in states that don't have full coverage
  let ret = {
    polygons: countyList
      .map((c) => {
        let cb = countyBoundaries[c.id];

        let boundary;
        let coverage;

        // the county information that we loaded into the database is missing some counties that we have in our dataset so we need to make sure we have coordinates
        if (cb && cb.coordinates) {
          if (cb.type === "Polygon") {
            boundary = cb.coordinates.map(mapArrayOfArrayToLatLng);
          } else {
            // then its a multipolygon
            boundary = cb.coordinates.reduce((acc, arr) => acc.concat(arr.map(mapArrayOfArrayToLatLng)), []);
          }
        }

        let color = fontColor.disabled;
        if (c.hasCoverage) {
          coverage = noCoverageStates.includes(c.stateAbbreviation) ? false : true;
          color = fontColor.primary;
        }
        if (flattenedAppraiserCountyIds?.some((id) => id === c.id)) {
          color = fontColor.error;
        }

        let style = {
          fillColor: color,
          strokeColor: fontColor.disabled,
        };

        if (coverage) {
          style.fillColor = backgroundColor.button;
          style.fillOpacity = 0.6;
        }

        return {
          id: c.id,
          type: "county", // type is used later for the mouseover logic
          paths: boundary,
          onMouseOver: mouseOver,
          onMouseOut: mouseOut,
          ...style,
        };
      })
      .filter((poly) => poly.paths), // filter out the polys that we didnt have county matches for
  };
  return ret;
};

// Title case and format county should live elsewhere but this project doesnt seem to have a basic util file
// Perhaps i will make one
export const titleCase = (str) => {
  if (!str) return str;
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(" ");
};

export const formatCounty = (county, state) => {
  return `${titleCase(county)} (${state.toUpperCase()})`;
};

export const sortCounty = (c1, c2) => `${c1.state}${c1.name}`.localeCompare(`${c2.state}${c2.name}`);

class Assignment extends React.Component {
  static contextType = AssignmentPinsContext;

  constructor(props) {
    super(props);

    this.dragStartY = null;
    this.heightStart = null;
    this.hasRendered = false;

    this.isAnyDateTimeOnSelectedDate = this.isAnyDateTimeOnSelectedDate.bind(this);
    this.getAssignedCaseDetails = this.getAssignedCaseDetails.bind(this);
    this.assignedCasesDateSelected = this.assignedCasesDateSelected.bind(this);
    this.getPinsForMap = this.getPinsForMap.bind(this);
    this.getFilteredCases = this.getFilteredCases.bind(this);
    this.getFilteredInspectors = this.getFilteredInspectors.bind(this);
    this.getFilteredInspectorsForFRCoverage = this.getFilteredInspectorsForFRCoverage.bind(this);
    this.getPinURL = this.getPinURL.bind(this);
    this.getPinTypesForDropdown = this.getPinTypesForDropdown.bind(this);
    this.getExtraFiltersForDropdown = this.getExtraFiltersForDropdown.bind(this);
    this.pinTypeFilterChanged = this.pinTypeFilterChanged.bind(this);
    this.onCountyFilterChanged = this.onCountyFilterChanged.bind(this);
    this.extraFiltersChanged = this.extraFiltersChanged.bind(this);
    this.isSelectionMade = this.isSelectionMade.bind(this);
    this.selectionCompleted = this.selectionCompleted.bind(this);
    this.deselectCases = this.deselectCases.bind(this);
    this.deselectAllPins = this.deselectAllPins.bind(this);
    this.onAssign = this.onAssign.bind(this);
    this.onUnassign = this.onUnassign.bind(this);
    this.selectionDetailsDisplayModeChanged = this.selectionDetailsDisplayModeChanged.bind(this);
    this.daysTillDueSelected = this.daysTillDueSelected.bind(this);
    this.designationSelected = this.designationSelected.bind(this);
    this.daysOldSelected = this.daysOldSelected.bind(this);
    this.getOptionsForDropdown = this.getOptionsForDropdown.bind(this);
    this.pinTypeValueRenderer = this.pinTypeValueRenderer.bind(this);
    this.countyTypeValueRenderer = this.countyTypeValueRenderer.bind(this);
    this.extraFiltersValueRenderer = this.extraFiltersValueRenderer.bind(this);
    this.showExtraDetails = this.showExtraDetails.bind(this);
    this.hideExtraDetails = this.hideExtraDetails.bind(this);
    this.showExtraInspectorDetails = this.showExtraInspectorDetails.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onRoutingClicked = this.onRoutingClicked.bind(this);
    this.onRoutingFinished = this.onRoutingFinished.bind(this);
    this.onInspectorSelected = this.onInspectorSelected.bind(this);
    this.triggerMapUpdate = this.triggerMapUpdate.bind(this);
    this.getTriggerMapUpdateObject = this.getTriggerMapUpdateObject.bind(this);
    this.getClearRoutingObject = this.getClearRoutingObject.bind(this);
    this.renderExtraDetails = this.renderExtraDetails.bind(this);
    this.extraFilterChecked = this.extraFilterChecked.bind(this);
    this.extraFilterChanged = this.extraFilterChanged.bind(this);
    this.onHeaderSearch = this.onHeaderSearch.bind(this);
    this.getAssigneeLabel = this.getAssigneeLabel.bind(this);
    this.onSearchResultClicked = this.onSearchResultClicked.bind(this);
    this.setMapController = this.setMapController.bind(this);
    this.setDragListener = this.setDragListener.bind(this);
    this.isStateListLoaded = this.isStateListLoaded.bind(this);
    this.setStateList = this.setStateList.bind(this);
    this.getMouseoverControl = this.getMouseoverControl.bind(this);
    this.updateCountyProficiency = this.updateCountyProficiency.bind(this);
    this.getPolygonsForMap = this.getPolygonsForMap.bind(this);
    this.polygonMouseOver = this.polygonMouseOver.bind(this);
    this.polygonMouseOut = this.polygonMouseOut.bind(this);
    this.loadPreferences = this.loadPreferences.bind(this);
    this.clearCaseIdFilter = this.clearCaseIdFilter.bind(this);
    this.getStateList = this.getStateList.bind(this);
    this.getCaseLocations = this.getCaseLocations.bind(this);
    this.updateInspectorsForCoverage = this.updateInspectorsForCoverage.bind(this);

    this.daysTillDueOptions = [
      { value: null, label: "All Due" },
      { value: 7, label: "Due This Week" },
      { value: 14, label: "Due In Two Weeks" },
      { value: 21, label: "Due In Three Weeks" },
      { value: 28, label: "Due In Four Weeks" },
      { value: 45, label: "Due In Five Weeks" },
    ];

    this.daysOldOptions = [
      { value: null, label: "All Ordered" },
      { value: 7, label: "Ordered One Week Ago" },
      { value: 14, label: "Ordered Two Weeks Ago" },
      { value: 21, label: "Ordered Three Weeks Ago" },
      { value: 28, label: "Ordered Four Weeks Ago" },
      { value: 45, label: "Ordered Five Weeks Ago" },
    ];

    this.designationsOptions = [
      { value: null, label: "Not Selected" },
      { value: BUILDERS_RISK, label: "Builders Risk Designation" },
      { value: COMMERCIAL_EXT, label: "Commercial Exterior Designation" },
      { value: COMMERCIAL_INT, label: "Commercial Interior Designation" },
      { value: FARM, label: "Farm Designation" },
      { value: HIGH_VALUE, label: "High Value Designation" },
      { value: LENDER, label: "Lender Designation" },
      { value: WIND, label: "Wind Designation" },
      { value: ELITE_HIGH_VALUE, label: "Elite High Value Designation" },
    ];

    let isTodayFriday = moment().day() === 5; //moment returns the day of the week as an int, starting with 0 on Sunday
    let isTodaySaturday = moment().day() === 6;

    let tomorrowDateOptionValue = isTodaySaturday ? 2 : 1; //if it's saturday, add 1 day to second option
    let theDayAfterTomorrowValue = isTodayFriday || isTodaySaturday ? 3 : 2; //if it's friday or saturday, add 2 days to the third option

    this.assignedCasesDateOptions = [
      { value: null, label: "No Date Selected" },
      { value: 0, label: "Today" },
      { value: tomorrowDateOptionValue, label: moment().add(tomorrowDateOptionValue, "days").format("dddd (M/D)") },
      { value: theDayAfterTomorrowValue, label: moment().add(theDayAfterTomorrowValue, "days").format("dddd (M/D)") },
    ];

    this.state = {
      stateList: null,
      showAssignedCasesDateSelector: false,
      showStateListPicker: false,
      selectedPinTypes: [],
      selectedPins: [],
      selectedInspectors: [],
      selectedCounties: [],
      extraFilters: [],
      countyOptions: [],
      flattenedAppraiserCountyIds: [],
      selectedAssignedCasesDay: this.assignedCasesDateOptions[0],
      assignedCasesDaysOut: null,
      daysDueOptionSelected: this.daysTillDueOptions[0],
      daysOldOptionSelected: this.daysOldOptions[0],
      designationsOptionSelected: this.designationsOptions[0],
      showRouting: false,
      routingResults: null,
      selectedInspector: null,
      selectionDetailsMode: DISPLAY_MODE_CASE_DETAILS,
      showExtraDetails: false,
      extraCaseDetails: null,
      mouseOverObject: null,
      selectionDetailsHeight: 345,
      searchResults: null, // null means no search, empty array means no results
      lastMapUpdate: 0, // manual timestamp that we pass to the map to tell it when to update, otherwise it updates every time state is set and this slows down the app greatly if theres a lot of pins
      caseIdFilter: props.location.state && props.location.state.caseIdFilter,
      selectedServiceRegions: [],
    };
    // this will be the reference to a map controller that lets us zoom in/out to the map once it mounts
    this.mapController = null;
  }

  componentDidMount() {
    if (!this.isStateListLoaded()) this.props.getStateList();
    this.props.getConfig();
    this.loadPreferences();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.isFetchingCountyList ||
        prevProps.isFetchingInspectors ||
        preferenceJustLoaded(AssignmentToolFilterExtras, prevProps.preferences, this.props.preferences)) &&
      !this.props.isFetchingCountyList &&
      !this.props.isFetchingInspectors &&
      this.props.inspectors &&
      this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL &&
      this.extraFilterChecked(EXTRA_FILTERS_COUNTY_PROFICIENCY, this.props.preferences.AssignmentToolFilterExtras.value)
    ) {
      this.updateCountyProficiency();
    }
    if (prevProps.isFetchingInspectors && !this.props.isFetchingInspectors) {
      this.updateInspectorsForCoverage();
    }
    if (
      this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE &&
      this.props.inspectorDetails?.inspectorLocation?.inspectorNumber &&
      prevProps.inspectorDetails?.inspectorLocation?.inspectorNumber !==
        this.props.inspectorDetails?.inspectorLocation?.inspectorNumber
    ) {
      this.props.frGeoCoverageMode(false);
      this.triggerMapUpdate();
    }
    // trigger map update to display region immediately for selected inspector if user just updated their region
    if (
      this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE &&
      prevProps.inspectorDetails?.serviceBoundary !== this.props.inspectorDetails?.serviceBoundary
    ) {
      this.triggerMapUpdate();
    }
    // call to get full inspector list to display all selected inspector regions to avoid refreshing page if user updated region individaul moments before
    if (
      this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE &&
      prevState.selectedInspectors.length !== this.state.selectedInspectors.length &&
      prevProps.inspectorDetails?.serviceBoundary !== this.props.inspectorDetails?.serviceBoundary
    ) {
      this.props.getInspectorLocations(this.props.preferences.AssignmentToolStateList.value);
    }
  }

  componentWillUnmount() {
    const { setCoreLayoutHeaderVisibility } = this.props;
    setCoreLayoutHeaderVisibility(true);
    if (this.props.clearLoadedCountyBoundaries) this.props.clearLoadedCountyBoundaries();
    this.props.clearAssignmentToolMemory();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.config.isFetching && !nextProps.config.isFetching) {
      this.setState({
        ...this.getTriggerMapUpdateObject(),
        selectedPinTypes: nextProps.config.casePinGroupingConfigs?.map((p) => p.id),
      });
    }

    if (this.props.isFetchingCases && !nextProps.isFetchingCases) {
      this.triggerMapUpdate();
    }

    if (
      (this.props.isFetchingCountyBoundaries || this.props.isFetchingAppraiserCountiesList) &&
      !nextProps.isFetchingCountyBoundaries &&
      !nextProps.isFetchingAppraiserCountiesList
    ) {
      let flattenedAppraiserCountyIds = nextProps.appraiserCountiesList.map((acl) => acl.county.id);

      flattenedAppraiserCountyIds = [...new Set(flattenedAppraiserCountyIds)];

      this.setState({ flattenedAppraiserCountyIds: flattenedAppraiserCountyIds, ...this.getTriggerMapUpdateObject() });
    }

    if (this.props.isFetchingCountyList && !nextProps.isFetchingCountyList) {
      let stateUpdate = {
        countyOptions: nextProps.countyList.sort(sortCounty).map((c) => {
          let county = formatCounty(c.name, c.state);
          return { value: county, label: county };
        }),
      };

      if (this.state.selectedCounties.length === 0)
        stateUpdate.selectedCounties = stateUpdate.countyOptions.map((c) => c.value);

      this.setState(stateUpdate);
    }

    if (nextProps.frCoverageHook?.data.coveragePolygons !== this.props.frCoverageHook?.data.coveragePolygons) {
      this.triggerMapUpdate();
    }

    if (this.props.isFetchingInspectors && !nextProps.isFetchingInspectors) {
      this.triggerMapUpdate();
    }

    if (this.props.fetchingCaseHeader && !nextProps.fetchingCaseHeader) {
      this.setState({ extraCaseDetails: nextProps.selectedCaseHeader });
    }

    if (
      this.preferencesJustLoaded(
        [AssignmentToolStateList, AssignmentToolFilterExtras],
        this.props.preferences,
        nextProps.preferences,
      )
    ) {
      let stateList = nextProps.preferences.AssignmentToolStateList.value;
      let newState = {};

      if (nextProps.preferences.AssignmentToolFilterExtras.value) {
        if (this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE) {
          // uncheck EXTRA_FILTERS_COUNTY_PROFICIENCY and EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER if it was checked in the assignment valuation tool
          newState.extraFilters = nextProps.preferences.AssignmentToolFilterExtras.value.filter(
            (f) => f !== EXTRA_FILTERS_COUNTY_PROFICIENCY && f !== EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER,
          );
        } else {
          newState.extraFilters = nextProps.preferences.AssignmentToolFilterExtras.value;
        }

        if (this.extraFilterChecked(EXTRA_FILTERS_FR_COUNTY_COVERAGE, newState.extraFilters))
          this.props.frCoverageHook?.setShowCoverage(true);
        if (this.extraFilterChecked(EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE, newState.extraFilters))
          this.props.frCoverageHook?.setShowZipCoverage(true);
        if (this.extraFilterChecked(EXTRA_FILTERS_HIDE_FR_COVERAGE_TOOLTIP, newState.extraFilters))
          this.props.frCoverageHook?.setShowTooltips(false);
        if (this.extraFilterChanged(EXTRA_FILTERS_ASSIGNED_CASES, newState.extraFilters))
          this.setState({ showAssignedCasesDateSelector: true });
      }

      if (!stateList) {
        newState.showStateListPicker = true;
        this.setState(newState);
      } else {
        newState.stateList = stateList;
        this.props.frCoverageHook?.setSelectedStates(stateList);
        this.setState(newState, this.loadStepsAfterStateList);
      }
    }

    if (preferenceJustLoaded(AssignmentToolCaseDetailsHeight, this.props.preferences, nextProps.preferences)) {
      if (nextProps.preferences.AssignmentToolCaseDetailsHeight.value)
        this.setState({ selectionDetailsHeight: nextProps.preferences.AssignmentToolCaseDetailsHeight.value });
    }

    if (
      this.preferencesJustLoaded(
        [
          AssignmentToolFilterInspectionTypeGroup,
          AssignmentToolFilterDue,
          AssignmentToolFilterOrdered,
          AssignmentToolFilterCounty,
        ],
        this.props.preferences,
        nextProps.preferences,
      )
    ) {
      let newState = {};

      if (nextProps.preferences.AssignmentToolFilterInspectionTypeGroup.value)
        newState.selectedPinTypes = nextProps.preferences.AssignmentToolFilterInspectionTypeGroup.value;
      if (nextProps.preferences.AssignmentToolFilterDue.value)
        newState.daysDueOptionSelected = nextProps.preferences.AssignmentToolFilterDue.value;
      if (nextProps.preferences.AssignmentToolFilterOrdered.value)
        newState.daysOldOptionSelected = nextProps.preferences.AssignmentToolFilterOrdered.value;
      if (nextProps.preferences.AssignmentToolFilterCounty.value)
        newState.selectedCounties = nextProps.preferences.AssignmentToolFilterCounty.value;

      this.setState({ ...this.getTriggerMapUpdateObject(), ...newState });
    }

    if (this.props.unassignStatus.unassigning && !nextProps.unassignStatus.unassigning) {
      this.props.getInspectorDetails(this.state.selectedInspector.inspectorNumber);
      this.props.getAssignedCases(this.state.selectedInspector.inspectorNumber);
      this.getCaseLocations();
    }

    if (this.props.lastSearchTime != nextProps.lastSearchTime) this.onHeaderSearch(nextProps.headerSearchText);
  }

  updateInspectorsForCoverage() {
    this.props.frCoverageHook?.setFieldReps(this.getFilteredInspectorsForFRCoverage());
  }

  loadStepsAfterStateList() {
    this.getCaseLocations();
    this.props.getInspectorLocations(this.getStateList(), this.extraFilterChecked(EXTRA_FILTERS_BREADCRUMBS));
    this.props.getZipCodes(this.getStateList());
    this.props.getCountiesByState(this.getStateList());
    if (this.props.getCasesWithAppts) this.props.getCasesWithAppts(this.getStateList(), ASSIGNED_CASES_DAYS_TO_LOOK);
  }

  loadPreferences() {
    this.props.loadPreference(AssignmentToolStateList);
    this.props.loadPreference(AssignmentToolCaseDetailsHeight);
    this.props.loadPreference(AssignmentToolFilterInspectionTypeGroup);
    this.props.loadPreference(AssignmentToolFilterCounty);
    this.props.loadPreference(AssignmentToolFilterDue);
    this.props.loadPreference(AssignmentToolFilterOrdered);
    this.props.loadPreference(AssignmentToolFilterExtras);
  }

  setDragListener(node) {
    if (node) {
      node.addEventListener("pointerdown", (event) => {
        if (event.button !== 0) return; // only capture left mouse click
        this.dragStartY = event.clientY;
        this.heightStart = this.state.selectionDetailsHeight;
        event.preventDefault();
        node.setPointerCapture(event.pointerId);
        window.getSelection().removeAllRanges();
        document.body.style.cursor = "ns-resize";
      });

      node.addEventListener("pointermove", (event) => {
        if (!this.dragStartY) return;
        let newHeight = this.heightStart + this.dragStartY - event.clientY;

        if (newHeight < (MIN_EXPANDED_DETALS_HEIGHT + COLLAPSED_DETAILS_HEIGHT) / 2) {
          newHeight = COLLAPSED_DETAILS_HEIGHT;
        } else if (newHeight < MIN_EXPANDED_DETALS_HEIGHT) {
          newHeight = MIN_EXPANDED_DETALS_HEIGHT;
        }

        if (newHeight > MAX_DETAILS_HEIGHT) newHeight = MAX_DETAILS_HEIGHT;

        this.setState({ selectionDetailsHeight: newHeight });
      });

      node.addEventListener("pointerup", (event) => {
        if (event.button !== 0) return; // only capture left mouse click
        document.body.style.cursor = "default";
        node.releasePointerCapture(event.pointerId);
        this.props.savePreference("AssignmentToolCaseDetailsHeight", parseInt(this.state.selectionDetailsHeight));
        this.dragStartY = null;
        this.heightStart = null;
      });
    }
  }

  // this will check the list of codes you pass in, and only return true once when all of the preferences from that list have been loaded
  // use this if you have loaded multiple preferences and want some logic to fire only once, when all of the preferences have loaded
  preferencesJustLoaded(codes, oldPrefs, newPrefs) {
    let anyPrefJustLoaded = codes.some((pref) => preferenceJustLoaded(pref, oldPrefs, newPrefs));
    let allPrefsLoaded = !codes.some((pref) => !newPrefs.hasOwnProperty(pref) || newPrefs[pref].isFetching);
    return anyPrefJustLoaded && allPrefsLoaded;
  }

  isStateListLoaded() {
    return this.props.stateList && Array.isArray(this.props.stateList) && this.props.stateList.length > 0;
  }

  getStateList() {
    return this.state.caseIdFilter ? [] : this.state.stateList;
  }

  setStateList(data) {
    let stateList = data.filter((d) => d.checked).map((d) => d.value);
    if (stateList.length) {
      // saving the AssignmentToolStateList preference will trickle through the receive props and cause us to continue with the rest of the data loading
      // we first set state to clear the state list picker because we want that to hide immediately to make it look like something is happening
      // then we start working on making everything else load
      // also setting stateList to null immediately will cause the tool to show a loading bar immediately
      this.setState({ showStateListPicker: false, stateList: null });
      setTimeout(() => {
        this.props.savePreference(AssignmentToolFilterCounty, null, () =>
          this.props.savePreference(AssignmentToolStateList, stateList),
        );
        this.setState({ stateList: stateList }, this.loadStepsAfterStateList);
        this.props.frCoverageHook?.setSelectedStates(stateList);
        this.deselectAllPins();
      });
    } else {
      alert("Please select at least one state");
    }
  }

  setMapController(mapController) {
    this.mapController = mapController;
  }

  getAssigneeLabel() {
    return this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL ? "Appraiser" : "Field Rep";
  }

  onHeaderSearch(searchText) {
    if (!searchText) return;

    let visibleCases = [];
    let hiddenCases = [];
    let visibleAssignees = [];
    let hiddenAssignees = [];
    let zips = [];

    let resultCountLimit = 100000;

    // these collection objects support a field called sortText in case you want search resuts sorted by something other than the searchText
    // i was using it for assignees but it is no longer needed

    if (this.props.cases && !this.props.isFetchingCases) {
      visibleCases = this.getFilteredCases().map((c) => {
        return {
          id: c.caseId,
          type: SEARCH_TYPE_CASE,
          searchableText: c.caseId,
        };
      });

      hiddenCases = this.props.cases
        .filter((c) => !visibleCases.some((vc) => vc.id === c.caseId))
        .map((c) => ({
          id: c.caseId,
          type: SEARCH_TYPE_CASE_HIDDEN,
          searchableText: c.caseId,
        }));
    }

    if (this.props.inspectors && !this.props.isFetchingInspectors) {
      visibleAssignees = this.getFilteredInspectors().map((i) => {
        return {
          id: i.inspectorNumber,
          type: SEARCH_TYPE_ASSIGNEE,
          searchableText: i.displayName,
        };
      });

      hiddenAssignees = this.props.inspectors
        .filter((i) => !visibleAssignees.some((va) => va.id === i.inspectorNumber))
        .map((i) => ({
          id: i.inspectorNumber,
          type: i.canBeAssignedCases ? SEARCH_TYPE_ASSIGNEE_HIDDEN_COUNTY : SEARCH_TYPE_ASSIGNEE_HIDDEN_FROM_MAP,
          searchableText: i.displayName,
        }));
    }

    if (this.props.zipCodes && !this.props.isFetchingZipCodes) {
      zips = this.props.zipCodes.map((z) => {
        return {
          id: z.zipCode,
          type: SEARCH_TYPE_ZIP_CODE,
          searchableText: z.zipCode,
        };
      });
    }

    let getTypeDisplayName = (t) => {
      switch (t) {
        case SEARCH_TYPE_ASSIGNEE:
          return this.getAssigneeLabel();
        case SEARCH_TYPE_ASSIGNEE_HIDDEN_COUNTY:
        case SEARCH_TYPE_ASSIGNEE_HIDDEN_FROM_MAP:
          return `${this.getAssigneeLabel()} (hidden)`;
        case SEARCH_TYPE_CASE:
          return "Control #";
        case SEARCH_TYPE_CASE_HIDDEN:
          return "Control # (hidden)";
        case SEARCH_TYPE_ZIP_CODE:
          return "Zip Code";
      }
    };

    let searchAndFormat = (r) =>
      r
        .filter((s) => s.searchableText) // will remove anything with an invalid search text ("", null, undefined, NaN)
        .map((o) => {
          return { ...o, searchableText: o.searchableText.toString(), typeDisplayName: getTypeDisplayName(o.type) };
        })
        .filter((s) => s.searchableText.toLowerCase().toString().indexOf(searchText.toLowerCase()) >= 0)
        .sort((a, b) => ((a.sortText || a.searchableText) > (b.sortText || b.searchableText) ? 1 : -1))
        .slice(0, resultCountLimit);

    // must search and format each one individually because we limit by results per type (at least we have the ability to) and sort each type individually
    let searchResults = searchAndFormat(visibleCases)
      .concat(searchAndFormat(hiddenCases))
      .concat(searchAndFormat(visibleAssignees))
      .concat(searchAndFormat(hiddenAssignees))
      .concat(searchAndFormat(zips));

    if (searchResults.length === 1) {
      this.onSearchResultClicked(searchResults[0]);
    } else {
      this.setState({ searchResults: searchResults });
    }
  }

  onSearchResultClicked(result) {
    switch (result.type) {
      case SEARCH_TYPE_ASSIGNEE:
      case SEARCH_TYPE_CASE: {
        this.deselectAllPins();
        let pin = this.getPinsForMap().find(
          (p) => p.type === (result.type === SEARCH_TYPE_ASSIGNEE ? "inspector" : "case") && p.id === result.id,
        );
        this.selectionCompleted([pin]);
        if (this.mapController) {
          this.mapController.setCenter(pin.latitude, pin.longitude);
          this.mapController.setZoom(16);
        }
        break;
      }
      case SEARCH_TYPE_CASE_HIDDEN:
        alert(`Case ${result.id} is hidden by your filters, please clear them and retry the search`);
        break;
      case SEARCH_TYPE_ASSIGNEE_HIDDEN_COUNTY:
        alert(
          `${this.getAssigneeLabel()} number ${result.id} is hidden by your county filter, please clear them and retry the search`,
        );
        break;
      case SEARCH_TYPE_ASSIGNEE_HIDDEN_FROM_MAP:
        alert(
          `${this.getAssigneeLabel()} number ${result.id} is hidden from the map by the "Can Be Assigned Cases" checkbox on the field rep maintenance page`,
        );
        break;
      case SEARCH_TYPE_ZIP_CODE:
        if (this.mapController) {
          let zip = this.props.zipCodes.find((z) => z.zipCode === result.id);
          this.mapController.setCenter(zip.latitude, zip.longitude);
          this.mapController.setZoom(15);
        }
        break;
    }
    this.setState({ searchResults: null });
  }

  selectionCompleted(selected) {
    if (this.props.isFRGeoCoverageMode || !selected.length) return;
    // if you get routing, and then make another selection, the routing will not go away despite all of the proper state variables being updated
    // if putting this in a setTimeout it works. There is probably a better way but I could not find it
    setTimeout(() => {
      selected = this.state.selectedPins.concat(selected);
      let casePins = selected.filter((pin) => pin.type === "case").map((pin) => pin.id);

      if (casePins.length) this.props.getCaseDetails(casePins);

      let selectedInspectors = this.props.inspectors.filter((i) =>
        selected.filter((pin) => pin.type === "inspector").some((p) => p.id === i.inspectorNumber),
      );

      selectedInspectors.map((i) =>
        i.serviceBoundary && !this.state.selectedServiceRegions.some((si) => si.inspectorNumber === i.inspectorNumber)
          ? this.state.selectedServiceRegions.push({
              boundary: i.serviceBoundary,
              inspectorNumber: i.inspectorNumber,
              inspectorName: i.displayName,
            })
          : null,
      );

      this.setState({
        ...this.getTriggerMapUpdateObject(),

        // conditional logic on next two lines because we want to show inspector details if no cases were selected
        selectionDetailsMode:
          !casePins.length && (selectedInspectors.length === 1 || this.state.selectedInspector)
            ? DISPLAY_MODE_INSPECTOR_CASES
            : DISPLAY_MODE_CASE_DETAILS,
        showExtraDetails: !casePins.length && (selectedInspectors.length === 1 || this.state.selectedInspector),

        selectedPins: selected,
        selectedInspectors: selectedInspectors,
      });
    }, 0);
  }

  isSelectionMade() {
    return this.state.selectedPins.length > 0;
  }

  pinTypeValueRenderer(selected, options) {
    if (selected.length === options.length) return "All Selected";
    if (selected.length) return `${selected.length} Selected`;
    return "Filter Inspection Types";
  }

  extraFiltersValueRenderer(selected, options) {
    if (selected.length === options.length) return "All Selected";
    if (selected.length) return `${selected.length} Selected`;
    return "Extra Filters";
  }

  countyTypeValueRenderer(selected, options) {
    if (selected.length === options.length) return "All Counties Selected";
    if (selected.length) return `${selected.length} Selected`;
    return "Filter Counties";
  }

  updateCountyProficiency() {
    if (!this.props.countyList) return;
    let countyKeys = Object.keys(this.props.countyBoundaries);
    let idsToLoad = this.props.countyList
      .filter((c) => !countyKeys.some((k) => this.props.countyBoundaries[k].id === c.id))
      .map((c) => c.id);
    if (idsToLoad.length) this.props.getCountyBoundaries(idsToLoad);
    this.props.getMultipleAppraiserCounties(this.props.inspectors.map((i) => i.id));
  }

  getPinURL(o, pinsPreferenceCode) {
    if (o.caseId || o.pinImageUrl) {
      let config = this.props.config.casePinGroupingConfigs.find((p) => p.id === o.pinGroupingConfigId);
      let selected = false;
      let surge = false;
      let isFiltered = false;

      if (o.caseId) {
        if (!config) return null;
        selected = this.state.selectedPins.some((sp) => sp.id === o.caseId && sp.type === "case");
        surge = !!o.frIncentivePercent;
        isFiltered = o.isFilteredCase;
      }

      if (!config && o.pinImageUrl) {
        config = o;
      }

      switch (pinsPreferenceCode) {
        case pinCodes.icons:
          return getCasePinIconURL(config.code, selected, surge, isFiltered);
        case pinCodes.default:
        default:
          return getCasePinURL(config.pinImageUrl, selected, surge, isFiltered);
      }
    } else if (o.inspectorNumber) {
      return getInspectorPinURL(
        this.state.selectedPins.some((sp) => sp.id === o.inspectorNumber && sp.type === "inspector"),
        o.isLiveLocation,
      );
    }
  }

  getFilteredCases(cases) {
    if (!cases) cases = this.props.cases;

    return cases.filter(
      (c) =>
        this.state.selectedPinTypes.includes(c.pinGroupingConfigId) &&
        this.state.selectedCounties.includes(formatCounty(c.county, c.stateAbbreviation)) &&
        (!this.extraFilterChecked(EXTRA_FILTERS_SURGE) || c.frIncentivePercent > 0) &&
        (!this.extraFilterChecked(EXTRA_FILTERS_PREFERRED_APPOINTMENT) || c.preferredAppointmentDate) &&
        (!this.state.daysDueOptionSelected.value || c.daysTillDue <= this.state.daysDueOptionSelected.value) &&
        (!this.state.daysOldOptionSelected.value || c.age >= this.state.daysOldOptionSelected.value) &&
        (!this.extraFilterChecked(EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER) ||
          !this.state.flattenedAppraiserCountyIds.some((id) => id === c.countyId)) &&
        (this.extraFilterChecked(EXTRA_FILTERS_NON_QUICKLIST_CASES) || c.isFilteredCase || !this.state.caseIdFilter) &&
        (!this.extraFilterChecked(EXTRA_FILTERS_AUTO_PULLED) || !c.wasAutomaticallyPulled) &&
        (!this.extraFilterChecked(EXTRA_FILTERS_APPRAISALS_ONLY) || c.isAppraisal),
    );
  }

  getFilteredInspectorsForFRCoverage() {
    return this.props.inspectors.filter((i) => {
      let designationFilter =
        !this.state.designationsOptionSelected.value ||
        i.designations.includes(this.state.designationsOptionSelected.value);
      let canBeAssignedCasesFilter = i.canBeAssignedCases;

      return designationFilter && canBeAssignedCasesFilter;
    });
  }

  getFilteredInspectors() {
    let isTraineeFilterChecked = this.extraFilterChecked(EXTRA_FILTERS_TRAINEES);

    return this.props.inspectors.filter((i) => {
      let countyFilter = this.state.selectedCounties.includes(formatCounty(i.county, i.stateAbbreviation));
      let canBeAssignedCasesFilter = i.canBeAssignedCases;
      let traineeFilter = !isTraineeFilterChecked || !i.isTrainee;
      let designationFilter =
        !this.state.designationsOptionSelected.value ||
        i.designations.includes(this.state.designationsOptionSelected.value);

      return countyFilter && canBeAssignedCasesFilter && traineeFilter && designationFilter;
    });
  }

  getMouseoverControl(obj) {
    if (obj?.type === "case") {
      if (this.props.assignedCasesWithAppts) {
        let assignedCase = this.props.assignedCasesWithAppts.find((c) => c.caseId === obj.id);
        if (assignedCase) {
          return {
            title: `Control # ${assignedCase.caseId.toString()}`,
            fields: [
              {
                label: "Field Rep",
                value: `${assignedCase.inspectorInfo.firstName + " " + assignedCase.inspectorInfo.lastName} (${assignedCase.inspectorInfo.inspectorNumber})`,
              },
              {
                label: "ETA Date/Time",
                value: assignedCase.autoAssignmentEta
                  ? moment(assignedCase.autoAssignmentEta).format("MM/DD/YYYY hh:mm A")
                  : assignedCase.inspectionEta //ETA can generally be inferred by the pin itself. So if it's an auto-assigned case, ETA will be for auto-assignment
                    ? moment(assignedCase.inspectionEta).format("MM/DD/YYYY hh:mm A")
                    : null,
              },
              {
                label: "Appt Date/Time",
                value: assignedCase.appointmentDate
                  ? moment(assignedCase.appointmentDate).format("MM/DD/YYYY hh:mm A")
                  : null,
              },
              { label: "Due Date", value: moment(assignedCase.customerDueDate).format("MM/DD/YYYY") },
            ],
          };
        }
      }
      let Case = this.props.cases.find((c) => c.caseId === obj.id);
      return {
        title: `Control # ${Case.caseId.toString()}`,
        fields: [{ label: "Due Date", value: Case.customerDueDate, dataType: DATA_TYPE_DAYS_ELAPSED }],
      };
    } else if (obj?.type === "inspector") {
      let inspector = this.props.inspectors.find((i) => i.inspectorNumber === obj.id);
      return {
        title: inspector.displayName,
        fields: [
          { label: "Email", value: inspector.email },
          ...(this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL
            ? [{ label: "Work Phone", value: inspector.workPhone }]
            : []),
          { label: "Home Phone", value: inspector.homePhone },
          { label: "Cell Phone", value: inspector.cellPhone },
          ...(inspector.lastLocationUpdateFormatted
            ? [{ label: "Location Updated", value: inspector.lastLocationUpdateFormatted }]
            : []),
          { label: "Notes", value: inspector.notes },
        ],
      };
    } else if (obj?.type === "county") {
      let county = this.props.countyBoundaries[obj.id].properties;
      let appraiserFields = this.props.appraiserCountiesList
        .filter((acl) => acl.county.id === county.id)
        .map((acl) => {
          let inspector = this.props.inspectors.find((i) => i.id === acl.appraiser.id);
          if (inspector)
            return {
              label: inspector.displayName,
              value: inspector.cellPhone || inspector.workPhone || inspector.homePhone,
              dataType: DATA_TYPE_PHONE_NUMBER,
            };
          else return { label: "Appraiser Not Loaded", value: " " }; // i cant imagine this will ever happen but i figured better safe than sorry
        });
      let appraiserCount = appraiserFields.length;
      if (!appraiserCount) appraiserFields = [{ label: "This county has no appraiser coverage", value: " " }];

      let maxAppraisersToShow = 20;
      let s = appraiserCount === 1 ? "" : "s";

      if (appraiserCount > maxAppraisersToShow) {
        appraiserFields.unshift({
          label: `Showing ${maxAppraisersToShow} of ${appraiserCount} Appraisers`,
          value: " ",
        });
      }

      return {
        title: `${appraiserCount > 0 ? `${appraiserCount} Appraiser${s} in ` : ""}${county.name}`,
        fields: appraiserFields,
      };
    } else if (obj?.type === "region") {
      return { title: " ", fields: [{ label: " ", value: obj.value }] };
    }
  }

  isAnyDateTimeOnSelectedDate(datesArray) {
    let d;
    let result = false;

    let dateStart = new Date();
    dateStart.setDate(dateStart.getDate() + this.state.assignedCasesDaysOut);
    dateStart.setHours(0, 0, 0);
    dateStart.setMilliseconds(0);
    let dateEnd = new Date(dateStart);
    dateEnd.setDate(dateStart.getDate() + 1);

    for (const date of datesArray) {
      if (date) {
        d = new Date(date);
        if (dateStart <= d && d < dateEnd) {
          result = true;
          break;
        }
      }
    }

    return result;
  }

  getPinsForMap(pinsPreferenceCode) {
    let pins = [];

    if (this.props.cases && !this.props.isFetchingCases) {
      pins = pins.concat(
        this.getFilteredCases(this.props.cases).map((c) => {
          return {
            id: c.caseId,
            latitude: c.latitude,
            longitude: c.longitude,
            icon: { url: this.getPinURL(c, pinsPreferenceCode), ...StandardPinSize },
            type: "case",
          };
        }),
      );
    }

    if (this.props.inspectors && !this.props.isFetchingInspectors) {
      pins = pins.concat(
        this.getFilteredInspectors().map((i) => {
          return {
            id: i.inspectorNumber,
            latitude: i.latitude,
            longitude: i.longitude,
            icon: { url: this.getPinURL(i, pinsPreferenceCode), ...StandardPinSize },
            type: "inspector",
          };
        }),
      );
    }

    if (
      this.props.assignedCasesWithAppts &&
      this.state.selectedInspector &&
      (this.state.assignedCasesDaysOut || this.state.assignedCasesDaysOut === 0)
    ) {
      pins = pins.concat(
        this.getFilteredCases(this.props.assignedCasesWithAppts)
          .map((c) => {
            if (
              (c.inspectorInfo.inspectorNumber === this.state.selectedInspector.inspectorNumber &&
                this.isAnyDateTimeOnSelectedDate([c.inspectionEta, c.autoAssignmentEta, c.appointmentDate])) ||
              (c.appointmentDate &&
                c.inspectorInfo.inspectorNumber !== this.state.selectedInspector.inspectorNumber &&
                this.isAnyDateTimeOnSelectedDate([c.appointmentDate]))
            )
              return {
                id: c.caseId,
                latitude: c.latitude,
                longitude: c.longitude,
                icon: { url: this.getPinURL(c, pinsPreferenceCode), ...StandardPinSize },
                type: "case",
              };
          })
          .filter((c) => c !== undefined),
      );
    }
    return pins;
  }

  getPinTypesForDropdown(pinsPreferenceCode) {
    return this.props.config.casePinGroupingConfigs
      .slice()
      .sort((a, b) => a.order - b.order)
      .map((p) => {
        let width = pinsPreferenceCode === pinCodes.icons ? "20px" : "14px";
        let height = pinsPreferenceCode === pinCodes.icons ? "42px" : "22px";
        return {
          label: (
            <span>
              <img
                src={this.getPinURL(p, pinsPreferenceCode)}
                style={{ width: width, height: height, marginLeft: "-6px", marginRight: "6px" }}
              />
              {p.name}
            </span>
          ),
          value: p.id,
        };
      });
  }

  polygonMouseOver(p) {
    this.setState({ mouseOverObject: p });
  }

  polygonMouseOut() {
    this.setState({ mouseOverObject: null });
  }

  getPolygonsForMap() {
    if (
      this.extraFilterChecked(EXTRA_FILTERS_COUNTY_PROFICIENCY) &&
      !this.props.isFetchingCountyBoundaries &&
      !this.props.isFetchingAppraiserCountiesList &&
      this.props.appraiserCountiesList &&
      this.props.countyBoundaries
    ) {
      return mapArrayOfPolygons(
        this.props.countyList,
        this.props.countyBoundaries,
        this.polygonMouseOver,
        this.polygonMouseOut,
        this.state.flattenedAppraiserCountyIds,
      );
    } else if (this.extraFilterChecked(EXTRA_FILTERS_FR_COUNTY_COVERAGE) && this.props.frCoverageHook) {
      return { polygons: this.props.frCoverageHook?.data.coveragePolygons };
    } else {
      return null;
    }
  }

  daysTillDueSelected(days) {
    this.setState({ ...this.getTriggerMapUpdateObject(), daysDueOptionSelected: days });
    this.props.savePreference(AssignmentToolFilterDue, days);
  }

  designationSelected(designation) {
    this.setState(
      { ...this.getTriggerMapUpdateObject(), designationsOptionSelected: designation },
      this.updateInspectorsForCoverage,
    );
  }

  daysOldSelected(days) {
    this.setState({ ...this.getTriggerMapUpdateObject(), daysOldOptionSelected: days });
    this.props.savePreference(AssignmentToolFilterOrdered, days);
  }

  // options is an array of object with value and label properties
  // onClick will be called with the object that was clicked on passed into the onClick
  getOptionsForDropdown(options, onClick) {
    return options.map((o) => {
      return {
        onClick: () => onClick(o),
        primaryText: o.label,
      };
    });
  }

  extraFilterChecked(filter, filters) {
    return (filters || this.state.extraFilters).includes(filter);
  }

  // returns 1 for just got checked, -1 for just got unchecked, 0 for unchanged
  extraFilterChanged(filter, oldSelected, newSelected) {
    return this.extraFilterChecked(filter, newSelected) - this.extraFilterChecked(filter, oldSelected);
  }

  getExtraFiltersForDropdown() {
    let filters = [
      {
        label: "Surge Only",
        value: EXTRA_FILTERS_SURGE,
      },
      {
        label: "Preferred Appointment Only",
        value: EXTRA_FILTERS_PREFERRED_APPOINTMENT,
      },
      {
        label: "Field Rep Live Locations",
        value: EXTRA_FILTERS_BREADCRUMBS,
      },
    ];

    if (this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE) {
      filters.push(
        {
          label: "Assigned cases",
          value: EXTRA_FILTERS_ASSIGNED_CASES,
        },
        {
          label: "Auto-Pulled Only",
          value: EXTRA_FILTERS_AUTO_PULLED,
        },
        {
          label: "Appraisals Only",
          value: EXTRA_FILTERS_APPRAISALS_ONLY,
        },
        {
          label: "Trainees",
          value: EXTRA_FILTERS_TRAINEES,
        },
        {
          label: "Field Rep County Coverage",
          value: EXTRA_FILTERS_FR_COUNTY_COVERAGE,
        },
        {
          label: "Field Rep Zip Code Coverage",
          value: EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE,
        },
      );

      if (this.extraFilterChecked(EXTRA_FILTERS_FR_COUNTY_COVERAGE)) {
        filters.push({
          label: "Hide FR Coverage Tool Tip",
          value: EXTRA_FILTERS_HIDE_FR_COVERAGE_TOOLTIP,
        });
      }
    }

    if (this.props.assignmentMode === ASSIGNMENT_MODE_APPRAISAL) {
      filters.push({
        label: "Appraiser County Proficiency",
        value: EXTRA_FILTERS_COUNTY_PROFICIENCY,
      });

      if (this.extraFilterChecked(EXTRA_FILTERS_COUNTY_PROFICIENCY)) {
        filters.push({
          label: "Show Cases in Counties with no Proficiency",
          value: EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER,
        });
      }
    }

    if (this.state.caseIdFilter) {
      filters.push({
        label: "Show Non-Quicklist Cases Matched by ZIP",
        value: EXTRA_FILTERS_NON_QUICKLIST_CASES,
      });
    }

    return filters;
  }

  pinTypeFilterChanged(selected) {
    this.setState({ ...this.getTriggerMapUpdateObject(), selectedPinTypes: selected });
    this.props.savePreference(AssignmentToolFilterInspectionTypeGroup, selected);
  }

  onCountyFilterChanged(selected) {
    this.setState({ ...this.getTriggerMapUpdateObject(), selectedCounties: selected });
    this.props.savePreference(AssignmentToolFilterCounty, selected);
  }

  extraFiltersChanged(selected) {
    // we set the filters once here and do the rest of the logic in a setTimeout so the UI is more responsive
    // after that we end up setting the extra filters a second time in case one filter changed another (current only example is unchecking EXTRA_FILTERS_COUNTY_PROFICIENCY will also uncheck EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER
    this.setState({ extraFilters: selected });

    let oldSelected = this.state.extraFilters;
    let newSelected = selected;

    setTimeout(() => {
      let displayCoverage = this.extraFilterChecked(EXTRA_FILTERS_FR_COUNTY_COVERAGE, selected);
      let displayZipBoundaries = this.extraFilterChecked(EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE, selected);

      // need to calc these first so we know what the user changed, since changing one could change the other and could cause some weird bugs
      let displayCoverageChanged = this.extraFilterChanged(EXTRA_FILTERS_FR_COUNTY_COVERAGE, oldSelected, newSelected);
      let displayZipChanged = this.extraFilterChanged(
        EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE,
        oldSelected,
        newSelected,
      );

      if (displayCoverageChanged) {
        this.props.frCoverageHook?.setShowCoverage(displayCoverage);

        if (!displayCoverage && displayZipBoundaries) {
          this.props.frCoverageHook?.setShowZipCoverage(false);
          newSelected = newSelected.filter((s) => s !== EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE);
        }
      }

      if (displayZipChanged) {
        this.props.frCoverageHook?.setShowZipCoverage(displayZipBoundaries);

        if (displayZipBoundaries && !displayCoverage) {
          this.props.frCoverageHook?.setShowCoverage(true);
          newSelected.push(EXTRA_FILTERS_FR_COUNTY_COVERAGE);
        }
      }

      let breadcrumbsChanged = this.extraFilterChanged(EXTRA_FILTERS_BREADCRUMBS, oldSelected, newSelected);
      if (breadcrumbsChanged) {
        this.props.getInspectorLocations(
          this.props.preferences.AssignmentToolStateList.value,
          breadcrumbsChanged === 1,
        );
      }

      let countyProficiencyChanged = this.extraFilterChanged(
        EXTRA_FILTERS_COUNTY_PROFICIENCY,
        oldSelected,
        newSelected,
      );
      // county proficiency just got turned on
      if (countyProficiencyChanged === 1) {
        this.updateCountyProficiency();
      } else if (countyProficiencyChanged === -1) {
        // county proficiency just got turned off
        // lets turn off proficiency case filter also
        newSelected = newSelected.filter((s) => s != EXTRA_FILTERS_COUNTY_PROFICIENCY_CASE_FILTER);
      }

      let coverageTooltipChanged = this.extraFilterChanged(
        EXTRA_FILTERS_HIDE_FR_COVERAGE_TOOLTIP,
        oldSelected,
        newSelected,
      );
      if (coverageTooltipChanged) {
        this.props.frCoverageHook.setShowTooltips(
          !this.extraFilterChecked(EXTRA_FILTERS_HIDE_FR_COVERAGE_TOOLTIP, newSelected),
        );
      }

      let assignedCasesFilterChanged = this.extraFilterChanged(EXTRA_FILTERS_ASSIGNED_CASES, oldSelected, newSelected);
      if (assignedCasesFilterChanged === 1) this.setState({ showAssignedCasesDateSelector: true });
      if (assignedCasesFilterChanged === -1) this.setState({ showAssignedCasesDateSelector: false });

      this.setState({ ...this.getTriggerMapUpdateObject(), extraFilters: newSelected });
      this.props.savePreference(AssignmentToolFilterExtras, newSelected);
    });
  }

  deselectCases(controlIdNumbersToRemove) {
    this.setState({
      ...this.getTriggerMapUpdateObject(),
      selectedPins: this.state.selectedPins.filter(
        (pin) => pin.type != "case" || !controlIdNumbersToRemove.includes(pin.id),
      ),
    });
    this.props.removeCasesFromCaseDetailsList(controlIdNumbersToRemove);
  }

  deselectAllPins() {
    this.setState({
      ...this.getTriggerMapUpdateObject(),
      ...this.getClearRoutingObject(),
      selectedPins: [],
      selectedInspectors: [],
      extraCaseDetails: null,
      showExtraDetails: false,
      selectedInspector: null,
      selectedServiceRegions: [],
    });
    this.props.clearMapSelection();
    if (this.props.assignmentMode === ASSIGNMENT_MODE_INSURANCE) {
      this.props.frGeoCoverageMode(false);
      this.props.saveFRServiceBoundary(null);
    }
  }

  onAssign(caseIds, inspectorNumber) {
    this.props.assignCasesToInspector(caseIds, inspectorNumber, (data) => {
      if (data) {
        this.deselectAllPins();
        this.props.removeCasesFromMap(caseIds);
      }
    });
  }

  onUnassign(caseIds) {
    this.props.unassignCases(caseIds);
  }

  showExtraDetails(o) {
    this.setState({ showExtraDetails: true, extraCaseDetails: null }, () => {
      this.props.getCaseHeader(o.caseLocation.caseId);
    });
  }

  hideExtraDetails() {
    if (this.state.selectionDetailsMode === DISPLAY_MODE_CASE_DETAILS) {
      this.setState({ showExtraDetails: false, extraCaseDetails: null });
    } else if (this.state.selectionDetailsMode === DISPLAY_MODE_INSPECTOR_CASES) {
      this.setState({ showExtraDetails: false });
    }
  }

  showExtraInspectorDetails() {
    this.setState({ showExtraDetails: true });
  }

  onMouseOver(pin) {
    // dont want mouseovers in ass tool if we are showing fr coverage, because it has its own mouse overs
    this.setState({ mouseOverObject: pin });
  }

  onMouseOut() {
    this.setState({ mouseOverObject: null });
  }

  onRoutingClicked() {
    if (this.state.showRouting) {
      this.setState(this.getClearRoutingObject());
    } else {
      this.setState({ showRouting: true });
    }
  }

  selectionDetailsDisplayModeChanged(newMode) {
    this.setState({ ...this.getClearRoutingObject(), selectionDetailsMode: newMode });
    if (newMode === DISPLAY_MODE_INSPECTOR_CASES) {
      this.setState({ showExtraDetails: true, extraCaseDetails: null });
    } else if (newMode === DISPLAY_MODE_CASE_DETAILS && !this.state.extraCaseDetails) {
      this.setState({ showExtraDetails: false });
    }
  }

  onRoutingFinished(result) {
    if (result.success && this.state.showRouting) {
      let durationMinutes = result.duration / 60; // value is in seconds, i want minutes
      let distanceMiles = result.distance * 0.000621371; // value is in meters, i want miles
      this.setState({
        routingResults: {
          driveAndSiteMinutes: this.props.caseDetails.reduce((total, cd) => total + cd.siteTime, 0) + durationMinutes,
          driveMinutes: durationMinutes,
          mileageCost: this.props.config.mileageRate * distanceMiles,
          distance: distanceMiles,
        },
      });
    } else {
      this.setState(this.getClearRoutingObject());
    }
  }

  onInspectorSelected(inspector) {
    if (this.props.assignedCasesWithAppts)
      this.props.updatePinsForAssignedCases(
        //Appointment cases (interiors, not ETAs) need the pin adjusted based on which FR is selected
        inspector.inspectorNumber,
        this.props.config.casePinGroupingConfigs.find((cpgc) => cpgc.name === PIN_NAME_SELECTED_FR_APPTS).id,
        this.props.config.casePinGroupingConfigs.find((cpgc) => cpgc.name === PIN_NAME_OTHER_FR_APPTS).id,
      );
    this.props.getInspectorDetails(inspector.inspectorNumber);
    this.props.getAssignedCases(inspector.inspectorNumber);
    this.setState({ selectedInspector: inspector });
  }

  getTriggerMapUpdateObject() {
    return { lastMapUpdate: Date.now() };
  }

  getClearRoutingObject() {
    return {
      showRouting: false,
      routingResults: null,
    };
  }

  triggerMapUpdate() {
    this.setState(this.getTriggerMapUpdateObject());
  }

  getStateListDialog(firstLoad) {
    let data = this.props.stateList.map((s) => ({ checked: false, label: s.stateName, value: s.stateAbbreviation }));

    if (!firstLoad) {
      data.forEach((d) => (d.checked = this.getStateList().some((s) => d.value === s)));
    }

    return (
      <MDialogSelectList
        title="Select States to View"
        data={data}
        onApply={this.setStateList}
        onClose={firstLoad ? undefined : () => this.setState({ showStateListPicker: false })}
        showSelectAll
      />
    );
  }

  getCaseLocations() {
    this.props.getCaseLocations(this.getStateList(), this.state.caseIdFilter);
  }

  clearCaseIdFilter() {
    this.setState({ caseIdFilter: null }, this.loadStepsAfterStateList);
    this.props.updateHeader({ topMenuTitle: null, dropdownTitle: null, buttons: null });
  }

  renderExtraDetails() {
    //They want to see case details when selecting a case in the grid after selecting a FR. As long as extra case details are there, render that instead regardless of display mode
    if (this.state.extraCaseDetails) {
      return (
        <div className="details-container">
          <CaseHeader
            isFetching={false}
            caseHeader={this.state.extraCaseDetails}
            controlNumber={parseInt(this.props.selectedCaseHeader.caseInfo.controlNumber)}
            verticalDisplay
            FRList={this.props.FRList}
            isFetchingFRList={this.props.isFetchingFRList}
            getFRList={this.props.getFRList}
            getCaseHeader={this.props.getCaseHeader}
            updatingCaseHeader={this.props.updatingCaseHeader}
            updateCaseHeader={this.props.updateCaseHeader}
            showHistory
          />
        </div>
      );
    }

    //If we don't check for fetchingCaseHeader, the second child of the split pane renders the FR profile while it's loading
    if (this.state.selectionDetailsMode === DISPLAY_MODE_INSPECTOR_CASES && !this.props.fetchingCaseHeader) {
      const { assignmentMode } = this.props;
      const { selectedInspector } = this.state;
      if (assignmentMode === ASSIGNMENT_MODE_INSURANCE) {
        return (
          selectedInspector && (
            <div className="details-container">
              <FieldRepProfileV2
                internetUserIdOverride={selectedInspector.internetUserId}
                frNumberOverride={selectedInspector.inspectorNumber}
                verticalDisplay
                regionManagerClosedCallback={() =>
                  this.props.getInspectorLocations(
                    this.getStateList(),
                    this.extraFilterChecked(EXTRA_FILTERS_BREADCRUMBS),
                  )
                } // need to update the inspector regions on the map
              />
            </div>
          )
        );
      } else {
        return (
          selectedInspector && (
            <div className="details-container">
              <AppraiserProfilePanel
                id={selectedInspector.id}
                internetUserIdForPanel={selectedInspector.internetUserId}
              />
            </div>
          )
        );
      }
    }
  }

  assignedCasesDateSelected(day) {
    this.setState({
      ...this.getTriggerMapUpdateObject(),
      selectedAssignedCasesDay: day,
      assignedCasesDaysOut: day.value,
    });
  }

  getAssignedCaseDetails() {
    //If "assigned cases" filter selected, they can then select a date for assigned cases. If that date is selected, only look at details for cases with ETAs or appointments
    if (
      this.state.selectedInspector &&
      this.props.assignedCases &&
      (this.state.assignedCasesDaysOut || this.state.assignedCasesDaysOut === 0)
    )
      return this.props.assignedCases.filter((c) =>
        this.isAnyDateTimeOnSelectedDate([
          c.caseLocation.inspectionEta,
          c.caseLocation.autoAssignmentEta,
          c.caseLocation.appointmentDate,
        ]),
      );
    return this.props.assignedCases;
  }

  render() {
    const { cases, inspectors, isFetchingCases, isFetchingInspectors, countyList, assignmentMode, frCoverageHook } =
      this.props;
    const pinPreferenceCode = this.context?.current?.code ?? pinCodes.default;

    if (this.state.showStateListPicker && this.isStateListLoaded() && !this.getStateList()) {
      return (
        <div>
          <MSpinner />
          {this.getStateListDialog(true)}
        </div>
      );
    } else if (
      !cases ||
      !inspectors ||
      !countyList ||
      isFetchingCases ||
      !this.getStateList() ||
      !this.props.config.casePinGroupingConfigs
    ) {
      return <MSpinner />;
    } else {
      const { setCoreLayoutHeaderVisibility } = this.props;
      setCoreLayoutHeaderVisibility(false);
      /*we were having issues with the assignment tool not always showing pins on first load
        changing filters would fix this, so that means it was something to do with whatever loaded last was not calling a trigger map update
        i could not pinpoint what this was, so as a last resort i wrote this logic that will always trigger a map update 1 second after the map initially renders
        this will ensure the map eventually will always load with pins */
      if (!this.hasRendered) {
        this.hasRendered = true;
        setTimeout(this.triggerMapUpdate, 1000);
      }

      let loadingCover = null;

      let showFRCountyCoverage = this.extraFilterChecked(EXTRA_FILTERS_FR_COUNTY_COVERAGE);
      let showFRZipCoverage = this.extraFilterChecked(EXTRA_FILTERS_DISPLAY_ZIP_BOUNDARIES_ON_COVERAGE);
      let loadingData = frCoverageHook?.data?.isLoading;

      if (loadingData && (showFRCountyCoverage || showFRZipCoverage) && (loadingData.value || isFetchingInspectors)) {
        let loadingMessages = [];
        if (isFetchingInspectors) loadingMessages.push("Loading inspector data...");
        if (loadingData.isLoadingZipData) loadingMessages.push("Loading zip data...");
        if (loadingData.isLoadingCountyData) loadingMessages.push("Loading county data...");
        if (loadingData.isLoadingMSAData) loadingMessages.push("Loading MSA data...");
        loadingCover = <LoadingCover loadingMessages={loadingMessages} />;
      }

      return (
        <div className="assignment-container">
          {this.state.mouseOverObject && (
            /*mouseovers are not implemented with map info boxes because that requires us to update the state of the map to show a mouseover which is very slow with a lot of cases*/
            <MToolTip {...this.getMouseoverControl(this.state.mouseOverObject)} />
          )}
          {this.state.showStateListPicker && this.getStateListDialog(false)}
          {this.state.searchResults && (
            <Dialog open={true} onClose={() => this.setState({ searchResults: null })} maxWidth="sm" fullWidth>
              <DialogTitle>
                <div>
                  {`${this.state.searchResults.length ? this.state.searchResults.length : "No"} Results For "${this.props.headerSearchText}"`}
                  <IconButton className="dialog-button" onClick={() => this.setState({ searchResults: null })}>
                    <Icon>close</Icon>
                  </IconButton>
                </div>
              </DialogTitle>
              <DialogContent>
                <TableContainer component="div" className="search-results-list">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className="assignment-result-type">Type</TableCell>
                        <TableCell className="assignment-result-value">Matched Value</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.searchResults.map((r) => (
                        <TableRow onClick={() => this.onSearchResultClicked(r)} key={r.type + "_" + r.id}>
                          <TableCell style={{ verticalAlign: "top", paddingTop: "5px" }}>{r.typeDisplayName}</TableCell>
                          <TableCell
                            className="assignment-result-value"
                            style={{ verticalAlign: "top", paddingTop: "5px" }}
                          >
                            {r.searchableText}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </DialogContent>
            </Dialog>
          )}
          <FauxHeader
            title={
              assignmentMode === ASSIGNMENT_MODE_APPRAISAL ? ASSIGNMENT_APPRAISAL_TITLE : ASSIGNMENT_INSURANCE_TITLE
            }
            dropdownTitle={"Assignment Actions"}
          >
            {this.state.showAssignedCasesDateSelector && (
              <MenuButton
                menuItems={this.getOptionsForDropdown(this.assignedCasesDateOptions, this.assignedCasesDateSelected)}
              >
                {this.state.selectedAssignedCasesDay.label}
              </MenuButton>
            )}
            <MultiSelect
              options={this.getPinTypesForDropdown(pinPreferenceCode)}
              selected={this.state.selectedPinTypes}
              onSelectedChanged={this.pinTypeFilterChanged}
              valueRenderer={this.pinTypeValueRenderer}
              disableSearch
            />
            {!this.state.caseIdFilter && (
              <RMDButton onClick={() => this.setState({ showStateListPicker: true })}>Filter States</RMDButton>
            )}
            <MultiSelect
              options={this.state.countyOptions}
              selected={this.state.selectedCounties}
              onSelectedChanged={this.onCountyFilterChanged}
              valueRenderer={this.countyTypeValueRenderer}
            />
            <MenuButton menuItems={this.getOptionsForDropdown(this.daysOldOptions, this.daysOldSelected)}>
              {this.state.daysOldOptionSelected.label}
            </MenuButton>
            <MenuButton menuItems={this.getOptionsForDropdown(this.daysTillDueOptions, this.daysTillDueSelected)}>
              {this.state.daysDueOptionSelected.label}
            </MenuButton>
            <MenuButton menuItems={this.getOptionsForDropdown(this.designationsOptions, this.designationSelected)}>
              {this.state.designationsOptionSelected.label}
            </MenuButton>
            <MultiSelect
              options={this.getExtraFiltersForDropdown()}
              selected={this.state.extraFilters}
              onSelectedChanged={this.extraFiltersChanged}
              hasSelectAll={false}
              valueRenderer={this.extraFiltersValueRenderer}
            />
            {this.state.showExtraDetails && <RMDButton onClick={this.hideExtraDetails}>{"Hide Details"}</RMDButton>}
            {!this.state.showExtraDetails && this.state.selectionDetailsMode === DISPLAY_MODE_INSPECTOR_CASES && (
              <RMDButton onClick={this.showExtraInspectorDetails}>{"Show Details"}</RMDButton>
            )}
            {this.state.caseIdFilter && (
              <RMDButton onClick={this.clearCaseIdFilter}>{"Remove QuickList Filter"}</RMDButton>
            )}
          </FauxHeader>
          <div className="map-and-details">
            <MSplitter
              firstChild={
                <div className="map-container">
                  {loadingCover}
                  <Map
                    getMapController={this.setMapController}
                    pins={this.getPinsForMap(pinPreferenceCode)}
                    onSelectionCompleted={this.selectionCompleted}
                    enableSelection
                    containerClass="map-control"
                    loadingClass="map-control"
                    mapClass="map-control"
                    onMouseOver={this.onMouseOver}
                    onMouseOut={this.onMouseOut}
                    manualUpdate
                    lastUpdate={this.state.lastMapUpdate}
                    onRoutingFinished={this.onRoutingFinished}
                    canEditFRServiceRegion={this.props.canEditFRServiceRegion}
                    canViewFRServiceRegion={this.props.canViewFRServiceRegion}
                    serviceBoundary={this.props.inspectorDetails?.serviceBoundary}
                    inspectorNumber={this.props.inspectorDetails?.inspectorLocation?.inspectorNumber}
                    inspectorName={this.props.inspectorDetails?.inspectorLocation?.displayName}
                    isFRGeoCoverageMode={this.props.isFRGeoCoverageMode}
                    saveFRServiceBoundary={this.props.saveFRServiceBoundary}
                    selectedServiceRegions={this.state.selectedServiceRegions}
                    routing={
                      this.state.showRouting && this.state.selectedInspector
                        ? {
                            origin: this.state.selectedInspector,
                            destination: this.state.selectedInspector,
                            waypoints: this.state.selectedPins.filter((pin) => pin.type === "case"),
                            onSuccess: () => {},
                            onError: () => {},
                          }
                        : null
                    }
                    {...this.getPolygonsForMap()}
                  />
                  {this.isSelectionMade() && <div className="resize-bar-vertical" ref={this.setDragListener} />}
                  {this.isSelectionMade() && (
                    <div
                      style={{
                        flex: `0 0 ${this.state.selectionDetailsHeight}px`,
                        height: `${this.state.selectionDetailsHeight}px`,
                      }}
                    >
                      <SelectionDetails
                        assignmentMode={this.props.assignmentMode}
                        appraisalStatus={this.props.appraisalStatus}
                        selectedCaseDetails={this.props.caseDetails}
                        isFetchingCaseDetails={this.props.isFetchingCaseDetails}
                        assignedCaseDetails={this.getAssignedCaseDetails()}
                        isFetchingAssignedCaseDetails={this.props.isFetchingAssignedCases}
                        selectedInspectors={this.state.selectedInspectors}
                        onDeselectCases={this.deselectCases}
                        onDeselectAllPins={this.deselectAllPins}
                        onAssign={this.onAssign}
                        onUnassign={this.onUnassign}
                        isUnassigning={this.props.unassignStatus.unassigning}
                        onCaseSelected={this.showExtraDetails}
                        onRoutingClicked={this.onRoutingClicked}
                        onDisplayModeChanged={this.selectionDetailsDisplayModeChanged}
                        isRouting={this.state.showRouting}
                        onInspectorSelected={this.onInspectorSelected}
                        isFetchingInspectorDetails={this.props.isFetchingInspectorDetails}
                        inspectorDetails={this.props.inspectorDetails}
                        routingData={this.state.routingResults}
                        displayMode={this.state.selectionDetailsMode}
                        collapsed={this.state.selectionDetailsHeight === COLLAPSED_DETAILS_HEIGHT}
                        hideExtraDetails={this.hideExtraDetails}
                        hideCasePins={this.pinTypeFilterChanged}
                        showExtraDetails={this.state.showExtraDetails}
                        frGeoCoverageMode={this.props.frGeoCoverageMode}
                        isFRGeoCoverageMode={this.props.isFRGeoCoverageMode}
                        tempFRGeoServiceRegion={this.props.tempFRGeoServiceRegion}
                        saveFRServiceBoundary={this.props.saveFRServiceBoundary}
                        makeToast={this.props.makeToast}
                        canEditFRServiceRegion={this.props.canEditFRServiceRegion}
                        getInspectorDetails={this.props.getInspectorDetails}
                        countyList={this.props.countyList.map((cl) => ({
                          label: `${cl.name} (${cl.state})`,
                          value: { lat: cl.latitude, lng: cl.longitude, id: cl.id },
                        }))}
                        countyBoundaries={this.props.countyBoundaries}
                        getCountyBoundaries={this.props.getCountyBoundaries}
                        hasFrAssignmentOverride={this.props.hasFrAssignmentOverride}
                      />
                    </div>
                  )}
                </div>
              }
              secondChild={this.state.showExtraDetails && this.renderExtraDetails()}
            />
          </div>
        </div>
      );
    }
  }
}

Assignment.propTypes = {
  assignedCasesWithPinsAdjusted: PropTypes.array,
  updatePinsForAssignedCases: PropTypes.func,
  assignedCasesWithAppts: PropTypes.array,
  isFetchingCasesWithAppointments: PropTypes.bool,
  frCoverageHook: PropTypes.object,
  getCasesWithAppts: PropTypes.func,
  getConfig: PropTypes.func.isRequired,
  getCaseLocations: PropTypes.func.isRequired,
  getInspectorLocations: PropTypes.func.isRequired,
  getStateList: PropTypes.func.isRequired,
  getZipCodes: PropTypes.func.isRequired,
  getCountiesByState: PropTypes.func.isRequired,
  getCaseDetails: PropTypes.func.isRequired,
  getAssignedCases: PropTypes.func.isRequired,
  removeCasesFromMap: PropTypes.func.isRequired,
  getInspectorDetails: PropTypes.func.isRequired,
  assignCasesToInspector: PropTypes.func.isRequired,
  unassignCases: PropTypes.func.isRequired,
  removeCasesFromCaseDetailsList: PropTypes.func.isRequired,
  clearMapSelection: PropTypes.func.isRequired,
  clearInspectorDetails: PropTypes.func.isRequired,
  clearLoadedCountyBoundaries: PropTypes.func,
  clearAssignmentToolMemory: PropTypes.func,
  getCaseHeader: PropTypes.func.isRequired,
  getCountyBoundaries: PropTypes.func,
  getMultipleAppraiserCounties: PropTypes.func,
  isFetchingCases: PropTypes.bool.isRequired,
  savePreference: PropTypes.func.isRequired,
  loadPreference: PropTypes.func.isRequired,
  loadPreferences: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  cases: PropTypes.array,
  assignStatus: PropTypes.object,
  unassignStatus: PropTypes.object,
  isFetchingInspectors: PropTypes.bool.isRequired,
  inspectors: PropTypes.array,
  isFetchingZipCodes: PropTypes.bool.isRequired,
  zipCodes: PropTypes.array,
  isFetchingCountyList: PropTypes.bool.isRequired,
  countyList: PropTypes.array,
  stateList: PropTypes.array,
  isFetchingCaseDetails: PropTypes.bool.isRequired,
  caseDetails: PropTypes.array,
  isFetchingAssignedCases: PropTypes.bool.isRequired,
  assignedCases: PropTypes.array,
  isFetchingInspectorDetails: PropTypes.bool.isRequired,
  inspectorDetails: PropTypes.object,
  selectedCaseHeader: PropTypes.object,
  fetchingCaseHeader: PropTypes.bool.isRequired,
  preferences: PropTypes.object,
  assignmentMode: PropTypes.string.isRequired,
  headerSearchText: PropTypes.string,
  lastSearchTime: PropTypes.number,
  countyBoundaries: PropTypes.object,
  isFetchingCountyBoundaries: PropTypes.bool,
  appraiserCountiesList: PropTypes.array,
  isFetchingAppraiserCountiesList: PropTypes.bool,
  updateHeader: PropTypes.func,
  location: PropTypes.object,
  updatingCaseHeader: PropTypes.bool,
  updateCaseHeader: PropTypes.func,
  FRList: PropTypes.array,
  isFetchingFRList: PropTypes.bool,
  getFRList: PropTypes.func,
  setCoreLayoutHeaderVisibility: PropTypes.func,
  appraisalStatus: PropTypes.string,
  frGeoCoverageMode: PropTypes.func,
  isFRGeoCoverageMode: PropTypes.bool,
  tempFRGeoServiceRegion: PropTypes.object,
  saveFRServiceBoundary: PropTypes.func,
  makeToast: PropTypes.func,
  canEditFRServiceRegion: PropTypes.bool,
  canViewFRServiceRegion: PropTypes.bool,
  hasFrAssignmentOverride: PropTypes.bool,
};

const mdtp = (dispatch) => ({
  setCoreLayoutHeaderVisibility(params) {
    dispatch(setCoreLayoutHeaderVisibility(params));
  },
});

export default connect(null, mdtp)(Assignment);
